export default {
    controlHub: {
        tabs: {
            containerSummary: "Resumen de Contenedores",
            companyStats: "Estadísticas de Empresa",
        },
        timeRange: {
            thisMonth: "Este Mes",
            last3Months: "Últimos 3 Meses",
            last6Months: "Últimos 6 Meses",
            last9Months: "Últimos 9 Meses",
            thisYear: "Este Año",
        },
        stats: {
            activePartners: "Socios Activos",
            teamMembers: "Miembros del Equipo",
        },
        tooltips: {
            docIssues: {
                title: "Contenedores con problemas documentales",
                description: "Número de contenedores con al menos un problema documental activo (documentos faltantes, fallos de verificación, errores de cruce)",
            },
            issues: {
                title: "Problemas",
                description: "Total de problemas activos en todos los contenedores",
            },
            atRisk: {
                title: "Envíos en riesgo",
                description: "Contenedores con puntuación de riesgo ≥ 25% (medio, alto, crítico)",
            },
            highRisk: {
                title: "Envíos de Alto Riesgo",
                description: "Contenedores con puntuación de riesgo ≥ 50% que requieren atención",
            },
            activePartners: {
                title: "Socios Comerciales Activos",
                description: "Empresas con las que tienes envíos activos (consignatarios, transitarios)",
            },
            teamMembers: {
                title: "Miembros del Equipo Activos",
                description: "Usuarios en tu organización con acceso a este workspace",
            },
        },
        riskyShipments: {
            title: "Envíos de Riesgo",
            description: "Contenedores de alto riesgo ordenados por valor en riesgo",
            emptyState: "No se encontraron envíos de alto riesgo",
        },
        companyProfile: {
            title: "Perfil de Empresa",
            profileCompleteness: "Completitud del Perfil",
            tradingPattern: "Patrón Comercial",
            volumeTier: "Nivel de Volumen",
            commodities: "Mercancías",
            tradeRoutes: "Rutas Comerciales",
            partners: "Socios Comerciales",
            containers: "Actividad de Contenedores",
            topHsCodes: "Códigos HS Principales",
            topRoutes: "Rutas Principales",
        },
    },
    admin: {
        title: "Dashboard",
        subtitle: "Vista general del sistema y gestión de cuentas",
        newAccount: "Nueva Cuenta",
        loading: "Cargando dashboard...",
        stats: {
            totalAccounts: "Total de Cuentas",
            activeAccounts: "Cuentas Activas",
            newThisMonth: "Nuevas Este Mes",
            suspendedAccounts: "Cuentas Suspendidas",
        },
        recentAccounts: {
            title: "Cuentas Recientes",
            description: "Últimas 5 cuentas creadas en el sistema",
            viewAll: "Ver todas",
            headers: {
                userType: "Tipo de Usuario",
                legalName: "Nombre Legal",
                entityType: "Tipo de Entidad",
                country: "País",
                status: "Estado",
                createdAt: "Fecha de Creación",
            },
            status: {
                active: "Activo",
                suspended: "Suspendido",
                inactive: "Inactivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
            containersWithDocIssues: "Con problemas doc",
            issues: "Con problemas",
            atRisk: "En riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores recibidos y colaboraciones",
        loading: "Cargando dashboard...",
        newOrderRequest: "Nueva Solicitud de Pedido",
        manageShippers: "Gestionar Expedidores",
        viewContainers: "Ver Contenedores",
        newOrderModal: {
            title: "Nueva Solicitud de Pedido",
            shipper: "Expedidor",
            shipperPlaceholder: "Selecciona un expedidor",
            targetWeek: "Semana Objetivo",
            packingList: "Lista de Empaque Solicitada",
            packingListPlaceholder: "Describe en detalle la lista de empaque solicitada...",
            notes: "Notas",
            notesPlaceholder: "Notas adicionales sobre el pedido...",
            submit: "Crear Pedido"
        },
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores recibidos",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                shipper: "Expedidor",
                route: "Ruta",
                progress: "Progreso",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
            },
        },
        monthlyTrend: {
            title: "Tendencia Mensual",
        },
        trendVsLastMonth: "vs mes pasado",
        receivedContainers: "Contenedores Recibidos",
        activeShippers: "Expedidores Activos",
        charts: {
            commodityDistribution: "Distribución de Mercancías",
            originCountries: "Países de Origen",
            arrivalPorts: "Puertos de Llegada",
        },
    },
};

